import DropdownViewModel from "../ViewModels/DropdownViewModel";

export default class TeamViewModel {
    public id: number = 0;
    public name: string = '';
    public members: DropdownViewModel[] = [];
    public teamLeaderId: string = '';
}
